import React from "react";
import { Navigate } from "react-router-dom";

type Props = { children: React.ReactNode };

export default function MerchantRouteGuard({ children }: Props) {
  const token = localStorage.getItem("merchant_access_token");
  const merchantId = localStorage.getItem("merchant_id");

  if (!token || !merchantId) {
    return <Navigate to="/merchant-login" replace />;
  }

  return <>{children}</>;
}
